import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';
import { BiLogoWordpress, BiCodeAlt, BiPalette, BiRocket, BiMobile } from 'react-icons/bi';

const WordpressEntwicklungHeader = () => {
    const { t } = useTranslations();

    return (
        <div className="mainbanner wp-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="wp-header__decoration wp-header__decoration--top"></div>
            <div className="wp-header__decoration wp-header__decoration--bottom"></div>

            <section className="services-area ptb-100 wp-header__section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="services-content it-service-content">
                                <div className="content">
                                    <div className="wp-header__badge">
                                        {t('wordpressDevelopment_header_upperTitle')}
                                    </div>

                                    <h1 
                                        className="wp-header__title"
                                        dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_header_title') }} 
                                    />

                                    <p className="wp-header__description">
                                        {t('wordpressDevelopment_header_description')}
                                    </p>

                                    {/* Feature-Karten */}
                                    <div className="row wp-header__features-row">
                                        <div className="col-md-6 mb-3">
                                            <div className="wp-header__feature-card">
                                                <BiPalette className="wp-header__feature-icon" />
                                                <h4 className="wp-header__feature-title">
                                                    {t('wordpressDevelopment_header_design')}
                                                </h4>
                                                <p className="wp-header__feature-text">
                                                    {t('wordpressDevelopment_header_design_desc')}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div className="wp-header__feature-card">
                                                <BiMobile className="wp-header__feature-icon" />
                                                <h4 className="wp-header__feature-title">
                                                    {t('wordpressDevelopment_header_responsive')}
                                                </h4>
                                                <p className="wp-header__feature-text">
                                                    {t('wordpressDevelopment_header_responsive_desc')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* CTA Button */}
                                    <Link href="/kontakt" className="wp-header__cta">
                                        <BiLogoWordpress style={{ marginRight: '8px' }} />
                                        {t('wordpressDevelopment_header_cta')}
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="services-image wp-header__image-wrapper">
                                <FadeInAnimation direction="right" delay={100}>
                                    <div className="image wp-header__image-card">
                                        {/* Dekorative Elemente */}
                                        <div className="wp-header__image-decoration"></div>

                                        <div className="wp-header__image-content">
                                            <Image
                                                src="/images/web-development/wordpress.webp"
                                                alt="Simplify Data - WordPress Entwicklung"
                                                width={0}
                                                height={0}
                                                sizes="100vw"
                                                className="wp-header__main-image"
                                            />
                                            <h3 
                                                className="wp-header__image-title"
                                                dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_header_title') }} 
                                            />
                                            <p className="wp-header__image-subtitle">
                                                {t('wordpressDevelopment_header_subtitle_image')}
                                            </p>

                                            <div className="wp-header__icon-badges">
                                                <div className="wp-header__icon-badge">
                                                    <BiCodeAlt className="wp-header__icon-badge-icon" />
                                                </div>
                                                <div className="wp-header__icon-badge">
                                                    <BiPalette className="wp-header__icon-badge-icon" />
                                                </div>
                                                <div className="wp-header__icon-badge">
                                                    <BiRocket className="wp-header__icon-badge-icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default WordpressEntwicklungHeader;
